import React from "react"
import { Outlet } from "react-router-dom"
import CenteredHeader from "../components/globals/CenteredHeader";
import Toaster from "../components/globals/Toaster"
import { ModalRootElement } from "../components/elements/Modal";

// tailwind css
import '../index.css'

const WorkspaceLayout: React.FC = (): React.ReactElement =>  {
  return (
    <div className="ui-panel-view flex h-full w-full flex-col overflow-hidden">
      <CenteredHeader />
      <div className="ui-layout-wrapper block min-h-0 w-full flex-1 overflow-y-auto overflow-x-hidden px-[28px]"><Outlet /></div>
      <Toaster />
      <ModalRootElement />
    </div>
  )
}

export default WorkspaceLayout
